import { UpdateTemplate, useCreateTemplateMutation, useUpdateTemplateMutation } from '@/services/gql/graphql.generated';
import { useCallback } from 'react';

export const useCreateTemplateFromUpdateTemplate = () => {
  const [{ error, fetching: updateFetching }, update] = useUpdateTemplateMutation();
  const [{ fetching: createFetching }, create] = useCreateTemplateMutation();

  const createTemplate = useCallback(
    async (requestedTemplate: UpdateTemplate) => {
      const result = await create({
        locationId: requestedTemplate.locationId,
        name: requestedTemplate.name
      });

      const newTemplate = result.data?.createTemplate;

      if (!newTemplate) {
        throw Error('Template create failed!');
      }

      const populateTemplate = await update({
        updateTemplate: {
          ...requestedTemplate,
          id: newTemplate.id
        }
      });

      return populateTemplate;
    },
    [create, update]
  );

  // `create` and `update` run sequentially as one logical operation, so callers need
  // `fetching` to stay true across both legs, not just drop back to false between them.
  return { createTemplate, error, fetching: createFetching || updateFetching };
};
